import { put, takeLatest, call } from 'redux-saga/effects'
import { getCompetingInterviewRequests } from '@/core/apiModules/competingInterviewRequests'
import * as competingInterviewRequestsModule from '../modules/competingInterviewRequests'
import { errorHandler } from '@/core/helpers/errorHelpers'

export function* fetchCompetingInterviewRequestsSaga({ meta }) {
  try {
    const response = yield call(getCompetingInterviewRequests, meta.hiringTeamId, meta.candidateProfileId)
    yield put(competingInterviewRequestsModule.fetchCompetingInterviewRequestsSuccess(response))
  } catch (err) {
    yield call(errorHandler, err)
  }
}

export default function* watchCompetingInterviewRequestsSaga() {
  yield takeLatest(competingInterviewRequestsModule.FETCH_COMPETING_INTERVIEW_REQUESTS, fetchCompetingInterviewRequestsSaga)
}
